
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function FightingStyleIndex() {
  return (
    <FSIndex
      data_type="fighting_style"
    />
  );
}
